
import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { GetShellCoursesResponseDto } from "../dtos/get-shell-courses.response.dto";
import { URLS } from "../../constants/constants";
import { AuthService } from "../../../common/services/auth.service";
import { GetCourseCodeAvailabilityResponseDto } from "../../../common/dtos/get-course-code-availability.response.dto";


@Injectable()
export class ShellCoursesService {
private http = inject(HttpClient);
private authService = inject(AuthService)
    
    getPaginatedShellCourses({skip,limit,sortField,sortOrder,searchQuery}:{skip:number,limit:number,sortField:string,sortOrder:string,searchQuery?:string}) : Promise<GetShellCoursesResponseDto>{
        let url = `${URLS.SHELL_COURSES_API}?skip=${skip}&limit=${limit}&sortField=${sortField}&sortOrder=${sortOrder}`;
        if (searchQuery) {
            url += `&searchQuery=${encodeURIComponent(searchQuery)}`;
        }
        return firstValueFrom(this.http.get<GetShellCoursesResponseDto>(url, {
            headers: this.authService.getAuthHeaders()
        })); 
    }
    getAllShellCourses() : Promise<GetShellCoursesResponseDto>{
        let url = `${URLS.SHELL_COURSES_API}/all`;
        return firstValueFrom(this.http.get<GetShellCoursesResponseDto>(url, {
            headers: this.authService.getAuthHeaders()
        })); 
    }
    checkAvailabilityFor(codes:{courseCodes:string[]}):Promise<GetCourseCodeAvailabilityResponseDto>{
        let url = `${URLS.SHELL_COURSES_API}/check-availability`;
        return firstValueFrom(this.http.post<GetCourseCodeAvailabilityResponseDto>(url, codes, {
            headers: this.authService.getAuthHeaders()
        })); 
    }
    createShellCourses(courseCodes:{courseCodes:string[]}){
         let url = `${URLS.SHELL_COURSES_API}`;
        return firstValueFrom(this.http.post(url, courseCodes, {
            headers: this.authService.getAuthHeaders()
        })); 
    }
}